// import React from "react";
// import Icon from "../Icon"
// import ChapterCircle from "../ChapterCircle";
// import brokerage from "../../svgs/Brokerage.svg";
// import svgSortAsc from "../../svgs/arrow-up.svg";
// import {getData} from "../../requests/CRUD";
// import {sortArray} from "../../utils";
// import {TRAINING} from "../../consts/tables";

// export default class extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             chapters: [],
//         }
//     }

//     componentDidMount() {
//         getData({
//             tableCode: TRAINING,
//             options: {
//                 filter: [{
//                     text: '',
//                     code: 'DELETED',
//                     type: 'null',
//                 }, {
//                     text: 'brokerage-continuum',
//                     code: 'PARENT_SLUG',
//                     type: 'exact',
//                 }],
//                 filterType: 'and',
//             },
//         }).then(res => {
//             if (res && res.success && Array.isArray(res.data) && res.data.length) {
//                 const chapters = sortArray(
//                     res.data.map(chapter => {
//                         return {
//                             id: chapter.SLUG,
//                             name: chapter.NAME,
//                             index: parseInt(chapter.INDEX),
//                             isSmall: (parseInt(chapter.INDEX) - 1) % 3 !== 0,
//                         }
//                     }), 'index');
//                 this.setState({chapters});
//             }
//         });
//     }

//     render() {
//         const {chapters} = this.state;

//         return (
//             <div className='BrokerageContinuum'>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container'>
//                         <div className='page-back-button' onClick={() => {history.back()}}>
//                             <Icon svg={svgSortAsc}/>
//                             Training
//                         </div>
//                         <div className='page-header'>
//                             <div className='page-title'>Brokerage Continuum</div>
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='page-body-container'>
//                     <div className='chapters-container'>
//                         <Icon svg={brokerage}/>
//                         {
//                             chapters.map(chapter =>
//                                 <div className='chapter-container' key={chapter.id}>
//                                     <ChapterCircle title={chapter.name} id={chapter.id} isSmall={chapter.isSmall}/>
//                                 </div>
//                             )
//                         }
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }
//#region Old Code
// import React from "react";
// import Icon from "../Icon"
// import ChapterCircle from "../ChapterCircle";
// import brokerage from "../../svgs/Brokerage.svg";
// import svgSortAsc from "../../svgs/arrow-up.svg";
// import {getData} from "../../requests/CRUD";
// import {sortArray} from "../../utils";
// import {TRAINING} from "../../consts/tables";

// export default class extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             chapters: [],
//         }
//     }

//     componentDidMount() {
//         getData({
//             tableCode: TRAINING,
//             options: {
//                 filter: [{
//                     text: '',
//                     code: 'DELETED',
//                     type: 'null',
//                 }, {
//                     text: 'brokerage-continuum',
//                     code: 'PARENT_SLUG',
//                     type: 'exact',
//                 }],
//                 filterType: 'and',
//             },
//         }).then(res => {
//             if (res && res.success && Array.isArray(res.data) && res.data.length) {
//                 const chapters = sortArray(
//                     res.data.map(chapter => {
//                         return {
//                             id: chapter.SLUG,
//                             name: chapter.NAME,
//                             index: parseInt(chapter.INDEX),
//                             isSmall: (parseInt(chapter.INDEX) - 1) % 3 !== 0,
//                         }
//                     }), 'index');
//                 this.setState({chapters});
//             }
//         });
//     }

//     render() {
//         const {chapters} = this.state;

//         return (
//             <div className='BrokerageContinuum'>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container'>
//                         <div className='page-back-button' onClick={() => {history.back()}}>
//                             <Icon svg={svgSortAsc}/>
//                             Training
//                         </div>
//                         <div className='page-header'>
//                             <div className='page-title'>Brokerage Continuum</div>
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='page-body-container'>
//                     <div className='chapters-container'>
//                         <Icon svg={brokerage}/>
//                         {
//                             chapters.map(chapter =>
//                                 <div className='chapter-container' key={chapter.id}>
//                                     <ChapterCircle title={chapter.name} id={chapter.id} isSmall={chapter.isSmall}/>
//                                 </div>
//                             )
//                         }
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }
//#endregion

import React from "react";
import Icon from "../Icon"
import ChapterCircle from "../ChapterCircle";
import brokerage from "../../svgs/Brokerage.svg";
import svgSortAsc from "../../svgs/arrow-up.svg";
import { getData } from "../../requests/CRUD";
import { sortArray } from "../../utils";
import { TRAINING } from "../../consts/tables";
import { GET_TRAINING } from "../Graphql/Queries/TrainingQuery";
import { ApolloConsumer } from "@apollo/client";
import { fetchData } from "../Service/graphQlService";

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chapters: [],
        }
        this.client = null;
    }

    componentDidMount() {
        if (this.client) {
            let payloadFilter = {
                "PARENT_SLUG": "brokerage-continuum"
              }
            //   this.client.query({
            //     query: GET_TRAINING, variables: {
            //         filter: [{ text: '', code: 'DELETED', type: 'null' },
            //         { text: 'brokerage-continuum', code: 'PARENT_SLUG', type: 'exact' }],
            //         filterType: 'and'
            //     }
            const token = localStorage.getItem('authToken');
            // this.client.query({
            //     query: GET_TRAINING,variables:{filters:payloadFilter},fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     }
            // })
            fetchData(GET_TRAINING, {filters:payloadFilter})
            .then(res => {
                if (res && res.data && Array.isArray(res.data.getTrainingFilter.data) && res.data.getTrainingFilter.data.length) {
                    const chapters = sortArray(
                        res.data.getTrainingFilter.data.map(chapter => {
                            return {
                                id: chapter.SLUG,
                                name: chapter.NAME,
                                index: parseInt(chapter.INDEX),
                                isSmall: (parseInt(chapter.INDEX) - 1) % 3 !== 0,
                            }
                        }), 'index');
                    this.setState({ chapters });
                }
            });
        }
    }

    render() {
        const { chapters } = this.state;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <div className='BrokerageContinuum'>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container'>
                                    <div className='page-back-button' onClick={() => { history.back() }}>
                                        <Icon svg={svgSortAsc} />
                                        Training
                                    </div>
                                    <div className='page-header'>
                                        <div className='page-title'>Brokerage Continuum</div>
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container'>
                                <div className='chapters-container'>
                                    <Icon svg={brokerage} />
                                    {
                                        chapters.map(chapter =>
                                            <div className='chapter-container' key={chapter.id}>
                                                <ChapterCircle title={chapter.name} id={chapter.id} isSmall={chapter.isSmall} />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>
        )
    }
}